import { ACTION } from './constants';

const initialState = {
    modalParameters: {},
    showModal: false,
    modalName: '',
    showHeader: true,
};

export default function modalReducer(state = initialState, action) {
    switch (action.type) {
        case ACTION.OPEN_MODAL:
            return { ...state, showModal: true, modalParameters: action.data.modalParameters, modalName: action.data.modalName };
        case ACTION.CLOSE_MODAL:
            return { ...state, showModal: false, modalParameters: null, modalName: '',showHeader: true };
        case ACTION.HIDE_MODAL_HEADER:
            return {...state, showHeader: false};
        case ACTION.SEND_OTP :
            return {...state , sendOtp:action.data};
        case ACTION.POST_REMUNERATION :
            return {...state , remunerationLogin:action.data};
        case ACTION.CLEAR_REMUNERATION :
            return {...state , remunerationLogin:{}}
        case ACTION.GET_REMUNERATION_YEARS :
            let year;
            if(action.data.fiscalYears)year=action.data.fiscalYears
            return {...state , remunerationYears:year};
        case ACTION.GET_ACCOUNT_STATEMENT :
            return {...state , accountStatement:action.data};
        case ACTION.VERIFY_OTP :
            return {...state , verifyOtpStatus: action.data}
        case ACTION.POST_INVEST_ETF :
            return {...state , registerData:action.data};
        case ACTION.CLEAR_VERIFY_OTP :
            return {...state , verifyOtpStatus: {}}
        case ACTION.CLEAR_SEND_OTP :
            return {...state , sendOtp:{}};
        default:
            return state;
    }
}
